import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fallback
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        fontSize: '1.2rem',
        color: '#667eea'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return fallback ? (
      <>{fallback}</>
    ) : (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '400px',
        flexDirection: 'column',
        gap: '1rem',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <h2 style={{ color: '#667eea', margin: 0 }}>Authentication Required</h2>
        <p style={{ color: '#666', margin: 0 }}>
          Please sign in to access this feature. This ensures your personal information and insurance data remain secure.
        </p>
        <div style={{
          backgroundColor: '#f8f9ff',
          padding: '1rem',
          borderRadius: '8px',
          border: '1px solid #e2e8ff',
          marginTop: '1rem',
          maxWidth: '400px'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#5a67d8' }}>
            🔒 Your privacy and security are our top priorities. All data is encrypted and protected.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;